<template>
    <div>
        <div class="row" v-for="contact in contacts" :key="contact.user_id">
            <div class="col-12 col-md-8 ">
                <div class="card mb-3">
                    <div class="row no-gutters">
                        <div class="col-2">
                            <div class="card-body">
                                <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
                                </svg>
                            </div>
                        </div>
                        <div class="col-10">
                            <div class="card-body pb-0">
                                <p class="mb-0 text-lg fw-bold">{{ contact.full_name }}</p>
                            </div>
                        </div>
                        <div class="col-12 offset-sm-2 col-sm-10">
                            <div class="card-body pt-0">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Relasjon') }}</p>
                                    </div>

                                    <div class="text-end">
                                        <p class="font-weight-normal mb-0">{{ contact.description }}</p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Mobil') }}</p>
                                    </div>

                                    <div class="text-end">
                                        <p class="font-weight-normal mb-0"><span v-if="contact.has_valid_mobile">{{ contact.mobile }}</span></p>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between">
                                    <div>
                                        <p class="fw-bold mb-0 text-sm">{{ $t('E-post') }}</p>
                                    </div>

                                    <div class="text-end">
                                        <p class="font-weight-normal mb-0">{{ contact.email }}</p>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between">
                                    <div>
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Personnummer') }}</p>
                                    </div>

                                    <div class="text-end">
                                        <p class="font-weight-normal mb-0">{{ getFnr(contact.fnr) }}</p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Adresse') }}</p>
                                    </div>

                                    <div class="text-end">
                                        <p class="font-weight-normal mb-0">{{ contact.address }}</p>
                                    </div>
                                </div>

                                <div class="d-flex flex-wrap justify-content-between" v-if="canToggleContactAccess">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" :id="'tabselev_access-' + contact.user_id" value="1" @change="toggleTabselevAccess(contact)" v-model="contact.tabselev_access">
                                        <label class="fw-bold mb-0 text-sm cursor-pointer" :for="'tabselev_access-' + contact.user_id"
                                        >{{ $t('Tillat innlogging for {name}', { name: contact.first_name }) }}</label>
                                    </div>

                                    <div v-if="contact.updated_access" class="text-sm">
                                        <span v-if="contact.tabselev_access" class="text-success">{{ $t('{name} har nå tilgang til {brandingName}', { name: contact.first_name, brandingName: brandingName }) }}</span>
                                        <span v-else class="text-danger">{{ $t('{name} har mistet tilgangen til {brandingName}', { name: contact.first_name, brandingName: brandingName }) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-show="loadingContacts">
            <div class="text-center col-12 py-3">
                <span class="spinner-border" role="status"></span>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-8 ">
                <div class="card mb-3">
                    <div class="row no-gutters">
                        <div class="col-2">
                            <div class="card-body">
                                <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
                                </svg>
                            </div>
                        </div>
                        <div class="col-10">
                            <div class="card-body pb-0">
                                <p class="mb-0 text-lg fw-bold">{{ $t('Ny kontakt') }}</p>
                            </div>
                        </div>
                        <div class="col-12 offset-sm-2 col-sm-10">
                            <div class="card-body pt-0">
                                <div class="row" :class="{'mb-2': !errorMessages.first_name }">
                                    <div class="col-5 col-md-7">
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Fornavn') }}</p>
                                    </div>
                                    <div class="text-end col-7 col-md-5">
                                        <input type="text" v-model="first_name" class="form-control form-control-sm text-end" :class="{'is-invalid': errorMessages.first_name }" :placeholder="$t('Fornavn')">
                                    </div>
                                </div>
                                <div class="text-danger text-end text-sm mb-2" v-if="errorMessages.first_name">
                                    {{ errorMessages.first_name }}
                                </div>
                                <div class="row" :class="{'mb-2': !errorMessages.last_name }">
                                    <div class="col-5 col-md-7">
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Etternavn') }}</p>
                                    </div>
                                    <div class="text-end col-7 col-md-5">
                                        <input type="text" v-model="last_name" class="form-control form-control-sm text-end" :class="{'is-invalid': errorMessages.last_name }" :placeholder="$t('Etternavn')">
                                    </div>
                                </div>
                                <div class="text-danger text-end text-sm mb-2" v-if="errorMessages.last_name">
                                    {{ errorMessages.last_name }}
                                </div>

                                <div class="row" :class="{'mb-2': !errorMessages.description }">
                                    <div class="col-5 col-md-7">
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Relasjon') }}</p>
                                    </div>
                                    <div class="text-end col-7 col-md-5">
                                        <input type="text" v-model="description" class="form-control form-control-sm text-end" :class="{'is-invalid': errorMessages.description }" :placeholder="$t('Eks: Mor eller Far')">
                                    </div>
                                </div>
                                <div class="text-danger text-end text-sm mb-2" v-if="errorMessages.description">
                                    {{ errorMessages.description }}
                                </div>

                                <div class="row" :class="{'mb-2': !errorMessages.mobile }">
                                    <div class="col-5 col-md-7">
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Mobil') }}</p>
                                    </div>
                                    <div class="text-end col-7 col-md-5">
                                        <input type="text" v-model="mobile" class="form-control form-control-sm text-end" :class="{'is-invalid': errorMessages.mobile }" :placeholder="$t('Mobil')">
                                    </div>
                                </div>
                                <div class="text-danger text-end text-sm mb-2" v-if="errorMessages.mobile" v-html="errorMessages.mobile"></div>

                                <div class="row" :class="{'mb-2': !errorMessages.email }">
                                    <div class="col-5 col-md-7">
                                        <p class="fw-bold mb-0 text-sm">{{ $t('E-post') }}</p>
                                    </div>
                                    <div class="text-end col-7 col-md-5">
                                        <input type="text" v-model="email" class="form-control form-control-sm text-end" :class="{'is-invalid': errorMessages.email }" :placeholder="$t('E-post')">
                                    </div>
                                </div>
                                <div class="text-danger text-end text-sm mb-2" v-if="errorMessages.email">
                                    {{ errorMessages.email }}
                                </div>

                                <div class="row" :class="{'mb-2': !errorMessages.fnr }">
                                    <div class="col-5 col-md-7">
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Fødseldato el. fødselsnummer') }}</p>
                                    </div>
                                    <div class="text-end col-7 col-md-5">
                                        <input type="text" v-model="fnr" class="form-control form-control-sm text-end" :class="{'is-invalid': errorMessages.fnr }" :placeholder="$t('Fødseldato el. fødselsnummer')">
                                    </div>
                                </div>
                                <div class="text-danger text-end text-sm mb-2" v-if="errorMessages.fnr">
                                    {{ errorMessages.fnr }}
                                </div>

                                <div class="row" :class="{'mb-2': !errorMessages.address }">
                                    <div class="col-5 col-md-7">
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Adresse') }}</p>
                                    </div>
                                    <div class="text-end col-7 col-md-5">
                                        <input type="text" v-model="address" class="form-control form-control-sm text-end" :class="{'is-invalid': errorMessages.address }" :placeholder="$t('Gateaddresse')">
                                    </div>
                                </div>
                                <div class="text-danger text-end text-sm mb-2" v-if="errorMessages.address">
                                    {{ errorMessages.address }}
                                </div>

                                <div class="row" :class="{'mb-2': !errorMessages.postal_code }">
                                    <div class="col-5 col-md-7">
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Postnummer') }}</p>
                                    </div>
                                    <div class="text-end col-7 col-md-5">
                                        <input type="text" v-model="postal_code" class="form-control form-control-sm text-end" :class="{'is-invalid': errorMessages.postal_code }" :placeholder="$t('Postnummer')">
                                    </div>
                                </div>
                                <div class="text-danger text-end text-sm mb-2" v-if="errorMessages.postal_code">
                                    {{ errorMessages.postal_code }}
                                </div>

                                <div class="row" :class="{'mb-2': !errorMessages.city }">
                                    <div class="col-5 col-md-7">
                                        <p class="fw-bold mb-0 text-sm">{{ $t('Poststed') }}</p>
                                    </div>
                                    <div class="text-end col-7 col-md-5">
                                        <input type="text" v-model="city" class="form-control form-control-sm text-end" :class="{'is-invalid': errorMessages.city }" :placeholder="$t('Poststed')">
                                    </div>
                                </div>
                                <div class="text-danger text-end text-sm mb-2" v-if="errorMessages.city">
                                    {{ errorMessages.city }}
                                </div>

                                <p class="mb-0">
                                    <small>{{ $t('Ved å legge til denne kontakten vil vedkommende få tilgang til din informasjon hos trafikkskolen via {brandingName}', {brandingName}) }}</small>
                                </p>
                                <div class="text-end">
                                    <span class="btn btn-success btn-sm fw-bold px-3 py-2" @click="save" :class="{'disabled':isDisabled}">
                                        {{ saveLabel }}
                                        <span v-if="isSaving" class="ml-2 fa fa-spinner fa-spin"></span>
                                    </span>
                                </div>
                                <div>
                                    <div class="alert alert-danger p-2 text-sm mt-2" v-if="generalError" v-html="generalError"></div>
                                    <div class="alert alert-success p-2 text-sm mt-2" v-if="generalSuccess">
                                        {{ generalSuccess }}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ios-hack-box"></div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import Api from '../../api/Profile'
import {LGDLogger} from "../../lib/LGDLogger";

const props = defineProps(['studentmobile', 'studentage'])
const contacts = ref([])
const loadingContacts = ref(true)
const first_name = ref('')
const last_name = ref('')
const description = ref('')
const email = ref('')
const mobile = ref('')
const fnr = ref('')
const address = ref('')
const postal_code = ref('')
const city = ref('')
const errorMessages = ref({})
const generalError = ref('')
const generalSuccess = ref('')
const saveLabel = ref($t('Lagre'))
const isSaving = ref(false)
const isDisabled = ref(false)

const takenMobileNumbers = computed(() => {
    const taken = [props.studentmobile];

    if (!contacts.value || (typeof contacts.value.map !== 'function')) {
        LGDLogger.warn('contacts.value is not an array', {
            mobile: mobile.value,
            contacts: contacts.value
        });

        return taken;
    }

    contacts.value.map(contact => {
        taken.push(contact.mobile.replace(/[^0-9]/g, '')) // Remove any non-numeric characters from numbers
    })

    return taken
})

const brandingName = computed(() => window.brandingName)

const canToggleContactAccess = computed(() => window.hasModule('DEMAND_DSF_CHECK_FOR_CONTACTS') && props.studentage >= 18)

const getContacts = () => {
    Api.GetContacts().then(res => {
        loadingContacts.value = false
        if (res.success) {
            contacts.value = res.data.contacts
        }
    })
}

const getFnr = (fnr) => {
    const nnid = L10n.nationalNumber.parse(String(fnr))
    if (nnid.isValidNationalNumber()) {
        return nnid.formatMasked()
    }
    return fnr
}

const save = () => {
    errorMessages.value = {}
    generalError.value = ''

    mobile.value = mobile.value.replace(/[^0-9]/g, ''); // Remove any non-numeric characters from form input
    if (mobile.value.length && takenMobileNumbers.value.indexOf(mobile.value) > -1) {
        errorMessages.value['mobile'] = $t('Mobilnummeret er allerede registrert<br/> på eleven eller en annen kontaktperson.')
        generalError.value = $t('Kunne ikke opprette kontakten. Rett opp feilene og prøv igjen.')
        return
    }
    saveLabel.value = $t('Lagrer...')
    isSaving.value = true
    isDisabled.value = true
    generalSuccess.value = ''

    Api.CreateContact({
        first_name: first_name.value,
        last_name: last_name.value,
        description: description.value,
        email: email.value,
        mobile: mobile.value,
        fnr: fnr.value,
        address: address.value,
        postal_code: postal_code.value,
        city: city.value,
    }).then(res => {
        if (res.success) {
            saveLabel.value = $t('Lagret')
            isSaving.value = false
            first_name.value = ''
            last_name.value = ''
            description.value = ''
            email.value = ''
            mobile.value = ''
            fnr.value = ''
            address.value = ''
            postal_code.value = ''
            city.value = ''
            getContacts()
            generalSuccess.value = $t('Kontakten har blitt lagret.')

            setTimeout(() => {
                saveLabel.value = $t('Lagre')
                isDisabled.value = false
            }, 2000)
        } else {
            errorMessages.value = res.errors
            if (res.errors.birthdate) {
                errorMessages.value.fnr = res.errors.birthdate
            }
            generalError.value = $t('Kunne ikke opprette kontakten. Rett opp feilene og prøv igjen.')
            saveLabel.value = $t('Lagre')
            isSaving.value = false
            isDisabled.value = false
        }
    }).catch(e => {
        generalError.value = $t('Det skjedde noe galt ved lagring av kontakten. Prøv igjen senere.')
    })
}

const toggleTabselevAccess = (contact) => {
    Api.UpdateContactAccess({
        contact_id: contact.user_id,
    }).then(res => {
        contact.tabselev_access = res.tabselev_access
        contact.updated_access = true
        contacts.value = {...contacts.value}
        setTimeout(() => {
            contact.updated_access = false
        }, 4000)
    })
}

onMounted(() => {
    getContacts()
})
</script>

<style scoped>
.ios-hack-box {
    height: 450px;
}
</style>